import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '@/api';
import {
    PaginatedResponse,
    User
} from '@/interfaces';

@Injectable({
    providedIn: 'root'
})
export class UsersService {

    constructor(private apiService: ApiService) {
    }

    listing(params: Record<string, any>): Observable<PaginatedResponse<User>> {
        return this.apiService.get<any>('/users', this.apiService.build(params)).pipe(
            map((res: any) => ({
                data: res.data,
                total: res.total,
                current_page: res.current_page,
                per_page: res.per_page
            }))
        );
    }

    create(data: Record<string, any>): Observable<User> {
        return this.apiService.post<User>('/users', data)
            .pipe(map(response => response.data));
    }

    edit(id: string, data: Record<string, any>): Observable<User> {
        return this.apiService.patch<User>(`/users/${id}`, data)
            .pipe(map(response => response.data));
    }

    delete(id: string): Observable<User> {
        return this.apiService.delete<User>(`/users/${id}`)
            .pipe(map(response => response.data));
    }

    export(params: Record<string, any>): Observable<Blob> {
        return this.apiService.postBlob('/users/export', params);
    }
}
